// extracted by mini-css-extract-plugin
module.exports = {"tabs":"AdvancedInfoForImage_tabs__QKrwk","tabItem":"AdvancedInfoForImage_tabItem__5Y4x0","infos":"AdvancedInfoForImage_infos__vLSev"};